import type { TranslationCatalog } from "../TranslationManager";

export const ta: TranslationCatalog = {
  "labels.cardNumber": "அட்டை எண்",
  "labels.expirationDate": "காலாவதி தேதி",
  "labels.cvc": "பாதுகாப்பு குறியீடு",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "MM / YY",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "உங்கள் அட்டை எண் தவறானது.",
  "errors.invalidExpiryDate": "உங்கள் அட்டையின் காலாவதி தேதி தவறானது.",
  "errors.invalidCvc": "உங்கள் அட்டையின் பாதுகாப்பு குறியீடு தவறானது.",
  "errors.incompleteCardNumber": "உங்கள் அட்டை எண் முழுமையடையவில்லை.",
  "errors.incompleteExpiryDate": "உங்கள் அட்டையின் காலாவதி தேதி முழுமையடையவில்லை.",
  "errors.incompleteCvc": "உங்கள் அட்டையின் பாதுகாப்பு குறியீடு முழுமையடையவில்லை.",
  "errors.expiredCard": "உங்கள் அட்டை காலாவதியாகிவிட்டது.",
  "aria.cardNumber": "அட்டை எண்",
  "aria.expirationDate": "காலாவதி தேதி",
  "aria.cvc": "பாதுகாப்பு குறியீடு",
  "aria.cardInput": "அட்டை தகவல்",
};
